import React, { useState, useEffect } from 'react'
/**
 * created by tian ruo jun
SVG列表,审核流
 *
 */
const svgList = (style) => {
    switch (style) {
        case "print":
            return "rmt_print";//打印

        case "preview":
            return "rmt_preview";//预览

        case "save":
            return "rmt_save";//保存

        case "act_publish":
            return "rmt_release";//发布

        case "act_goback":
            return "rmt_share-with-me";//撤回（撤回给自己）

        case "act_backtrack":
            return "rmt_fanhui";//返回（写稿人）

        case "act_submit":
            return "rmt_submit";//提交

        case "act_deserted":
            return "rmt_qiyong";//放弃

        case "remarks":
            return "rmt_log";//查看备注

        case "import":
            return "rmt_import";//导入

        case "rmt_caiyong":
            return "rmt_caiyong";//采用

        case "rmt_shiqu":
            return "rmt_shiqu";//拾取

        case "rmt_zhongxinshiqu":
            return "rmt_zhongxinshiqu";//重新采用

        default:
            return "rmt_submit";//提交

    }
};
export default svgList

